<section>
  <app-expert-group-portal-header
    *ngIf="expertGroupPortal"
    selectedNavItem="discussions"
    [expertGroupPortal]="expertGroupPortal"
  ></app-expert-group-portal-header>

  <div class="container m-b-xxl m-t-alt" *ngIf="discussion">
    <div class="columns is-multiline">
      <div
        class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
      >
        <h2 class="title is-2 mb-0">
          {{ discussion.title }}
        </h2>
        <div class="columns discussion--intro">
          <div
            class="column"
            [ngClass]="{
              'is-12': !discussion.image,
              'is-8-tablet is-9-desktop': discussion.image
            }"
          >
            <div [innerHTML]="discussion.content"></div>
          </div>
          <div class="column is-4tablet is-3-desktop" *ngIf="discussion.image">
            <img
              class="image"
              [src]="discussion.image?.medium"
              [alt]="discussion.title"
            />
          </div>
        </div>
        <disqus [identifier]="discussion.slug" [url]="currentPath"></disqus>
      </div>
    </div>
    <ng-container *ngIf="discussion.relatedDiscussionIds?.length">
      <div class="columns">
        <div class="column is-12">
          <h3 class="title is-3 mb-0">Related discussions</h3>
        </div>
      </div>

      <div class="columns is-multiline" *ngIf="!loadingRelatedDiscussions">
        <div
          class="column is-12-touch is-4-desktop has-button-short"
          [id]="'discussion-card-' + discussion.id"
          *ngFor="let discussion of discussion.relatedDiscussions"
        >
          <app-discussion-card
            [discussion]="discussion"
            [expertGroupPortal]="expertGroupPortal"
          ></app-discussion-card>
        </div>
      </div>
      <div class="columns" *ngIf="loadingRelatedDiscussions">
        <div class="column is-6-tablet is-4-desktop">
          <div class="lc lc--discussion">
            <div></div>
          </div>
        </div>
        <div class="column is-6-tablet is-4-desktop">
          <div class="lc lc--discussion">
            <div></div>
          </div>
        </div>
        <div class="column is-6-tablet is-4-desktop">
          <div class="lc lc--discussion">
            <div></div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="!discussion" class="container mt-alt m-b-xxxl">
    <div class="columns">
      <div
        class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
      >
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
        <div class="temporary-item temporary-item--dark temporary-desc"></div>
      </div>
    </div>
  </div>
</section>
